/**
 * 태그 API.
 * 태그 라우트는 data 봉투 없이 최상위 키로 응답한다 (예: { success, tags }).
 */

import { apiService } from './api'

export interface TagSummary {
  _id: string
  name: string
  color: string
  /** 스키마 기본값이 있어 서버가 항상 내려준다 */
  usageCount: number
}

interface TagsResponse {
  success: boolean
  tags?: TagSummary[]
  message?: string
}

interface TagResponse {
  success: boolean
  tag?: TagSummary
  message?: string
}

interface SuggestionsResponse {
  success: boolean
  suggestions?: TagSummary[]
  message?: string
}

export const tagApi = {
  async list(): Promise<TagSummary[]> {
    const response = await apiService.client.get<TagsResponse>('/tags')
    return response.data.tags ?? []
  },

  async create(input: {
    name: string
    color?: string
  }): Promise<TagSummary | null> {
    const response = await apiService.client.post<TagResponse>('/tags', input)
    return response.data.tag ?? null
  },

  async remove(tagId: string): Promise<void> {
    await apiService.client.delete(`/tags/${tagId}`)
  },

  /** 입력 중 자동완성 후보 */
  async suggestions(query: string): Promise<TagSummary[]> {
    const response = await apiService.client.get<SuggestionsResponse>(
      '/tags/suggestions',
      { params: { q: query } }
    )
    return response.data.suggestions ?? []
  },
}

export default tagApi
